<script>
import { createEventDispatcher } from 'svelte';
import { formatFinancialNumber } from './formatFinancialNumber.js';
import RevenueChart from './RevenueChart.svelte';
import Popup from './Popup.svelte';

export let listing;
const dispatch = createEventDispatcher();

function close() {
    dispatch('close');
}
</script>

<Popup on:close maxWidth="max-w-2xl" padding="1.5rem">
  <div class="flex justify-between items-start mb-4">
    <h2 class="text-2xl font-bold">{listing.name}</h2>
  </div>

  {#if listing.image}
    <img src={listing.image} alt={listing.name} class="w-full !h-36 object-contain md:!h-64 md:!object-cover rounded-lg mb-4">
  {/if}

  <div class="grid grid-cols-2 gap-4 mb-4">
    <div>
      <p class="font-semibold">Price:</p>
      <p>{formatFinancialNumber(listing.price, listing.currency)}</p>
    </div>
    <div>
      <p class="font-semibold">Location:</p>
      <p>{listing.location || 'Not provided'}</p>
    </div>
    {#if typeof listing.revenue === 'object' || typeof listing.ebitda === 'object' || typeof listing.grossSales === 'object' || typeof listing.sellersDiscretionaryEarnings === 'object'}
      <div class="col-span-2">
        <p class="font-semibold">Financial Data:</p>
        <RevenueChart {listing} />
      </div>
    {:else}
      <!-- Display individual financial data if not in chart format -->
      {#if listing.revenue}
        <div>
          <p class="font-semibold">Revenue:</p>
          <p>{formatFinancialNumber(listing.revenue, listing.currency)}</p>
        </div>
      {/if}
      {#if listing.ebitda}
        <div>
          <p class="font-semibold">EBITDA:</p>
          <p>{formatFinancialNumber(listing.ebitda, listing.currency)}</p>
        </div>
      {/if}
    {/if}
  </div>

  <p class="mb-4">{listing.description}</p>

  {#if listing.staff}
    <p class="mb-2"><span class="font-semibold">Staff:</span> {listing.staff}</p>
  {/if}

  {#if listing.facilities}
    <p class="mb-2">
      <span class="font-semibold">Facilities:</span> 
      {#if typeof listing.facilities === 'string'}
        {listing.facilities}
      {:else if Array.isArray(listing.facilities)}
        {listing.facilities.join(', ')}
      {:else if typeof listing.facilities === 'object'}
        {Object.entries(listing.facilities).map(([key, value]) => `${key}: ${value}`).join(', ')}
      {:else}
        Unable to display facilities information
      {/if}
    </p>
  {/if}

  {#if listing.transition}
    <p class="mb-2"><span class="font-semibold">Transition:</span> {listing.transition}</p>
  {/if}

  {#if listing.includesProperty}
    <p class="mb-2"><span class="font-semibold">Includes Property:</span> Yes</p>
  {/if}

  {#if listing.saleType}
    <p class="mb-2"><span class="font-semibold">Sale Type:</span> {listing.saleType}</p>
  {/if}

  <div class="mt-6">
    <a href="https://app.bizzer.ai/?id={listing.id}" class="bg-amber-400 text-black px-4 py-2 rounded hover:bg-amber-600 transition-colors">
      View Full Listing
    </a>
  </div>
</Popup>

<style>
  p{
    margin-bottom: 0rem;
  }
</style>
